<template>
  <div class="resultForm">
    <template v-if="state === 1">
      <div class="stateBg">
        <img src="@/assets/imgs/Signing.png" alt="" />
      </div>
      <div class="state">签署中</div>
      <div class="tag">请耐心等待</div>
    </template>
    <template v-else-if="state === 2">
      <div class="stateBg">
        <img src="@/assets/imgs/signSuccess.png" alt="" />
      </div>
      <div class="state">签署成功</div>
      <div class="tag" v-if="signInfo.callBack">
        3s倒计时后跳转回调地址
      </div>
      <div id="launch-btn" v-else-if="wxCallBack"></div>
    </template>
    <template v-if="state === 3">
      <div class="stateBg">
        <img src="@/assets/imgs/signFail.png" alt="" />
      </div>
      <div class="state">签署失败</div>
      <div class="tag"></div>
    </template>

    <div class="button-group">
      <van-button type="primary" @click="goBackMini" v-if="mini"
        >返回小程序</van-button
      >
    </div>
  </div>
</template>
<script>
  import Api from '@/api'
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        state: 1,
        mini: false,
      }
    },
    computed: {
      ...mapState({
        signInfo: state => state.sign,
      }),
      wxCallBack() {
        return this.signInfo.wxCallBack
      },
    },
    mounted() {
      if (this.signInfo.type === '1') {
        this.init()
      } else {
        this.contractSign()
      }
    },
    methods: {
      init() {
        this.state = 2
        if (this.signInfo.callBack) {
          setTimeout(() => {
            window.location.href = this.signInfo.callBack
          }, 3000)
        } else if (this.wxCallBack) {
          window.wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
              this.mini = true
            } else {
              this.mini = false
              this.wx_launch()
            }
          })
        }
      },
      goBackMini() {
        window.wx.miniProgram.navigateBack()
      },
      wx_launch() {
        const content = `
        <button class="test-btn">跳转小程序</button>
        <style>
          .test-btn{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 44px;
            background: #1676ff;
            border-radius: 4px;
            color:#fff;
            font-size:16px;
            border:none;
          }
        </style>
        `
        const btn = document.getElementById('launch-btn') // 获取元素
        const script = document.createElement('script') // 创建script内容插槽 避免template标签冲突
        script.type = 'text/wxtag-template' // 使用script插槽 必须定义这个type
        script.text = content // 自定义的html字符串内容
        const html = `<wx-open-launch-weapp style="width:100%;display:block;" username="${this.wxCallBack.username}" path="${this.wxCallBack.path}">${script.outerHTML}</wx-open-launch-weapp>`
        btn.innerHTML = html // html字符串赋值
        // 点击按钮 正常跳转触发
        btn.addEventListener('launch', function(e) {
          console.log('success')
        })
        // 点击跳转 抛出异常
        btn.addEventListener('error', function(e) {
          console.log('fail', e.detail)
          alert(`跳转异常 - ${e.detail}`)
        })
      },
      async contractSign() {
        try {
          const params = await this.$store.dispatch('sign/getTransformParams')
          const { data } = await Api.contractSign(params, {
            commitType: 'form',
          })
          this.init()
        } catch (error) {
          console.log(error)
          this.state = 3
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  .resultForm {
    padding-top: 76px;
    .stateBg {
      width: 100%;
      text-align: center;
      margin-bottom: 16px;
      img {
        width: 120px;
      }
    }
    .state {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      color: #111a34;
      text-align: center;
      line-height: 24px;
      margin-bottom: 4px;
    }
    .tag {
      font-size: 12px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #677283;
      line-height: 24px;
    }
    .button-group {
      text-align: center;
      margin-top: 20px;
    }
  }
</style>
